$('div.alert').each(function () {
    var $this = $(this)
    $('<a class="la la-window-close" href=""/>')
        .appendTo($this)
        .on('click', function (event) {
            event.preventDefault()
            $this.slideUp()
        })
})

window.setInterval(function () {
    $.ajax({
        url: '/ajax/keepalive.php',
    })
}, 30 * 60 * 1000)

$('a.hamburger').on('click', function (event) {
    event.preventDefault()
    $('body').toggleClass('shownav')
})

$(document).ready(function() {
    if($('#address').length) {
        var address = document.getElementById('address');
        var address_options = {
            componentRestrictions: { country: 'nz' }
        };
        var addressautocomplete = new google.maps.places.Autocomplete(address, address_options);
    }

    // Add Date Picker to 'jqdate' class
    $('.jqdate').datepicker({ dateFormat: 'yy-mm-dd' });
    // Add Select JS library to all 'select' elements
    $('select').select2()
    // Add Stupid Table library to all 'sortable-table' classes
    $('.sortable-table').stupidtable();

    // Add required attribute to all elements with class 'required'
    $('.required').each(function() {
       $(this).prop('required',true);
    });
});


$('.tabset').each(function() {
    var $set = $(this),
        $row = $('<ul>').addClass('tabrow').prependTo($set),
        $tabs = $set.find('.tab'),
        started = false
    $tabs.each(function() {
        var $tab = $(this),
            name = $(this).data('tabname'),
            label = name,
            code = name.replace(/[^A-Za-z0-9]+/,'_'),
            $link = $('<a>').appendTo(
                $('<li>').appendTo($row)
            )
                .text(label)
                .click(function(event) {
                    event.preventDefault()
                    $tabs.hide()
                    $tab.show()
                    $row.find('li').removeClass('active')
                    $(this).closest('li').addClass('active')
                    if(location.hash != "#" + code) {
                        history.replaceState({
                            tab: name
                        },"","#" + code)
                    }
                })
        if(typeof $(this).data('tabcount') !== 'undefined') {
            $link.append($('<span class="count"/>').text('(' + $(this).data('tabcount') + ')'))
        }
        if(location.hash == "#" + code) {
            $(document).ready(function() {
                $link.click()
            })
            started = true
        }
    })
    if(!started) {
        $(document).ready(function() {
            $row.find('li a').first().click()
        })
    }
})


$(".autocomplete.regplate").autocomplete({
    source: function (request, response) {
        $.getJSON('/ajax/getvehicles', {
            term: request.term,
        }, response)
    },
    minLength: 0,
    select: function (event, ui) {
        if (window.location.pathname == "/vehicles") {
            window.location.href = window.origin + "/vehicle?id=" + ui.item.value
        }
        $(this).val(ui.item.label)
        $(this).next().val(ui.item.value)
        return false
    }
});

// Listen and add selected vehicles to bulk export or delete array
$(".object-select").change(function () {
    var checkedObjects = new Array();
    $(".object-select:checked").each(function () {
        checkedObjects.push($(this).attr("data-id"));
    });
    $(".selected-objects").val(checkedObjects);

    // Display bulk edit form
    if (checkedObjects.length > 0) {
        $(".bulk-delete-btn").addClass("show");
    } else {
        $(".bulk-delete-btn").removeClass("show");
    }
});

$(".object-select-all").change(function () {
    let $this = $(this);
    if ($(this).is(":checked")) {
        $('.object-select').prop('checked', true);
        var checkedObjects = new Array();
        $(".object-select:checked").each(function () {
            checkedObjects.push($(this).attr("data-id"));
        });
        $(".selected-objects").val(checkedObjects);
        $(".bulk-delete-btn").addClass("show");
    } else {
        $('.object-select').prop('checked', false);
        $(".selected-objects").val("");
        $(".bulk-delete-btn").removeClass("show");
    }
})

$('.bulk-export-btn').click(function(e) {
    e.preventDefault();
    $('.bulk-option').val('export');
    $(this).parent('form').submit();
})

$('.bulk-delete-btn').click(function(e) {
    e.preventDefault();
    $('.bulk-option').val('delete');
    $(this).parent('form').submit();
})

$('.delete-vehicle-type').click(function() {
    var vehicleTypeID = $(this).attr('data-id');
    $.ajax({
        url: '/ajax/removevehicletype',
        type: 'POST',
        data: {
            "id": vehicleTypeID
        },
        success: function(col) {
            console.log("Successfully removed vehicle type");
            location.reload();
        },
    });
});
